import { Space } from '@procurify/ui'

import { TaxInclusiveCheckbox } from '@webapp/components/TaxInclusiveCheckbox'
import { TaxSelectCreate } from '@webapp/components/TaxSelectCreate'
import { type Tax } from '@webapp/models'
import { type ColumnTypeData } from '../../types/DataTable.types'

// Remove this when AP_10171_AP_INLINE_EDITS is removed
export const APItemTaxCell = ({
  billItem,
  onUpdateItemTax,
  isDisabled,
}: ColumnTypeData['AP_ITEM_TAX']) => {
  return (
    <Space direction='horizontal' align='center'>
      <Space.Item width={1 / 8}>
        <TaxInclusiveCheckbox
          disabled={
            billItem.isPODepositItem || billItem.taxId === null || isDisabled
          }
          checked={billItem.taxIsInclusive}
          onChange={(checked) => {
            onUpdateItemTax(billItem.uuid, billItem.taxId, checked)
          }}
        />
      </Space.Item>
      <Space.Item grow={1}>
        <TaxSelectCreate
          isDisabled={isDisabled}
          value={
            billItem.taxId
              ? ({
                  id: billItem.taxId,
                  is_inclusive: billItem.taxIsInclusive,
                  name: billItem.taxName,
                  percentage: billItem.taxPercentage.toString(),
                } as Tax)
              : null
          }
          menuPortalTarget={document.body}
          onTaxCreated={(tax) =>
            onUpdateItemTax(billItem.uuid, tax?.id, billItem.taxIsInclusive)
          }
          onTaxSelected={(tax) =>
            onUpdateItemTax(billItem.uuid, tax?.id, billItem.taxIsInclusive)
          }
        />
      </Space.Item>
    </Space>
  )
}
